"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialSetupTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.CommercialSetupTransport = typebox_1.Type.Object({
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    equipmentChargeSkuID: typebox_1.Type.String({ format: 'uuid' }),
    prorationSkuID: typebox_1.Type.String({ format: 'uuid' }),
});
//# sourceMappingURL=CommercialSetup.js.map